import Vue from 'vue';
import Vuex from 'vuex';

import accept from './modules/accept.module';
import auth from './modules/auth.module';
import club from './modules/club.module';
import confirm from './modules/confirm.module';
import events from './modules/events.module';
import exam from './modules/exam.module';
import fee from './modules/fee.module';
import layout from './modules/layout.module';
import mailTemplate from './modules/mailTemplate.module';
import menu from './modules/menu.module';
import mobile from './modules/mobile.module';
import notification from './modules/notification.module';
import permission from './modules/permission.module';
import presences from './modules/presences.module';
import profile from './modules/profile.module';
import role from './modules/role.module';
import schedule from './modules/schedule.module';
import setting from './modules/setting.module';
import sport from './modules/sport.module';
import system from './modules/system.module';
import team from './modules/team.module';
import terms from './modules/terms.module';
// TODO : wczytywanie modułów do store powinno być automatyczne. Wszystkie pliki w ./modules

Vue.use(Vuex);
// Create a new store

const store = new Vuex.Store({
  actions: {},
  getters: {},
  mutations: {},
  state: {},
  modules: {
    auth,
    notification,
    system,
    mobile,
    confirm,
    layout,
    menu,
    profile,
    club,
    sport,
    team,
    role,
    mailTemplate,
    setting,
    permission,
    schedule,
    events,
    presences,
    accept,
    terms,
    fee,
    exam
  }
});

export default store;
